import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { emailAuthApi, passwordIsValid } from "../api/emailAuthApi";
import { AuthLayout, AuthField, AuthError, AuthNotice, PasswordChecklist, CodeInput } from "../components/AuthLayout";

export default function EmailResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const canSubmit = token && passwordIsValid(password) && password === confirm && code.length === 6;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await emailAuthApi.resetPassword({ token, password, confirm_password: confirm, code });
      setDone(true);
    } catch (err) {
      setCode("");
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <AuthLayout eyebrow="Password reset" title="Password updated">
        <AuthNotice>Sign in with your new password and your authenticator code.</AuthNotice>
        <Link className="auth-btn auth-btn--primary" to="/email-signin">Go to sign in</Link>
      </AuthLayout>
    );
  }

  if (!token) {
    return (
      <AuthLayout eyebrow="Password reset" title="This link can't be used">
        <AuthError message="The reset link is missing or incomplete." />
        <div className="auth-links"><Link className="auth-link" to="/email-signin">← Back to sign in</Link></div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout eyebrow="Password reset" title="Choose a new password"
      subtitle="Enter a new password and the current code from your authenticator app.">
      <form className="auth-form" onSubmit={submit}>
        <AuthField label="New password">
          <input className="auth-input" type="password" autoComplete="new-password" autoFocus required
            value={password} onChange={(e) => setPassword(e.target.value)} />
        </AuthField>
        <AuthField label="Confirm new password">
          <input className="auth-input" type="password" autoComplete="new-password" required
            value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </AuthField>
        <PasswordChecklist password={password} confirm={confirm} />
        <AuthField label="Authenticator code">
          <CodeInput value={code} onChange={setCode} autoFocus={false} />
        </AuthField>
        <AuthError message={error} />
        <button className="auth-btn auth-btn--primary" type="submit" disabled={busy || !canSubmit}>
          {busy ? "Updating…" : "Update password"}
        </button>
        <div className="auth-links"><Link className="auth-link" to="/email-signin">← Back to sign in</Link></div>
      </form>
    </AuthLayout>
  );
}
